import webSDKCore from '@tencent/ti18n-websdkcore';
import { initReactI18next } from '@tencent/ti18n-react-sdk';
export { Trans, withTranslation, useTranslation } from '@tencent/ti18n-react-sdk';

export const initI18n = (resource) => {
  webSDKCore
    .use(initReactI18next)
    .init({
      appid: '60405', // 应用id，用于访问CDN线上配置的标识符
      ns: ['default'], // 命名空间
      defaultNS: ['default'], // 默认命名空间
      // lng: 'en', // 默认中文
      fallbackLng: 'en',
      resources: jsonToI18nResource(resource),
      preload: ['en'], // 预加载的语言
      partialBundledLanguages: false, // 部分从sdk传入，部分从connector获取
      debug: false, // 开启调试
      // backend: {
      //   sVersion: '624',
      //   sCdnPrefix: 'https://camp-pre.honorofkings.com',
      // },
      // load: 'currentOnly',
      detection: {
        order: ['navigator'],
        caches: [],
      },
    })
    .then((t) => {
      console.log('初始化webSDKCore完成,用时:\n');
      console.log('当前resource数据：', webSDKCore.services.resourceStore.toJSON());
      // webSDKCore.changeLanguage("zh");
      return t;
    })
    .catch((error) => {
      console.warn('i18n init fail:', error);
      return error;
    });
};

export const jsonToI18nResource = (jsonObject) => {
  const ns = {};
  for (const [_name, module] of Object.entries(jsonObject)) {
    for (const [lang, trans] of Object.entries(module as object)) {
      if (!ns[lang]) {
        ns[lang] = {};
      }

      let temp = {};
      if (typeof Object.values(trans)[0] === 'string') {
        temp = trans;
      } else {
        for (const moduleTrans of Object.values(trans)) {
          Object.assign(temp, moduleTrans);
        }
      }
      if (ns[lang].default) {
        Object.assign(ns[lang].default, temp);
      } else {
        ns[lang]['default'] = temp;
      }
    }
  }
  return ns;
};
